// =============== =============== =============== =============== =============== =============== STICKY
function coHandleStickyOnScroll(selector) {
  let lastScroll = window.scrollY;
  const el = document.querySelector(selector);
  if (!el) return;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll < lastScroll) {
      el.classList.add('co-sticky');
    } else {
      el.classList.remove('co-sticky');
    }
    lastScroll = currentScroll;
  });
}
coHandleStickyOnScroll('.co-p-main-media');
coHandleStickyOnScroll('.co-p-main-content');

// =============== =============== =============== =============== =============== =============== ACCORDION
class Accordion {
    constructor(element, options = {}) {
        this.accordion = element;
        this.options = {
            allowMultiple: element.dataset.allowMultiple === 'true' || options.allowMultiple || false,
            initialOpen: element.dataset.initialOpen || options.initialOpen || null,
            openAll: element.dataset.openAll === 'true' || options.openAll || false,
            animationDuration: options.animationDuration || 300,
            ...options
        };
        this.headers = this.accordion.querySelectorAll('[data-accordion-header]');
        this.contents = this.accordion.querySelectorAll('[data-accordion-content]');
        
        this.init();
    }

    init() {
        this.accordion.classList.add('accordion-initialized');
        this.headers.forEach((header, index) => {
            header.setAttribute('aria-expanded', 'false');
            header.setAttribute('aria-controls', `accordion-content-${index}`);
            header.id = `accordion-header-${index}`;
            const content = this.contents[index];
            content.setAttribute('aria-labelledby', `accordion-header-${index}`);
            content.id = `accordion-content-${index}`;
            content.setAttribute('role', 'region');
            header.addEventListener('click', () => this.togglePanel(index));
            header.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.togglePanel(index);
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.focusNextHeader(index);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.focusPreviousHeader(index);
                }
            });
        });

        if (this.options.initialOpen !== null) {
            const initialIndex = parseInt(this.options.initialOpen);
            if (initialIndex >= 0 && initialIndex < this.headers.length) {
                this.openPanel(initialIndex);
            }
        }

        if (this.options.openAll) {
            this.openAllPanels();
        }

        setTimeout(() => {
            this.accordion.classList.add('accordion-initialized-after');
        }, 500);
    }

    togglePanel(index) {
        const header = this.headers[index];
        const isOpen = header.classList.contains('active');
        
        if (isOpen) {
            this.closePanel(index);
        } else {
            if (!this.options.allowMultiple) {
                this.closeAllPanels();
            }
            this.openPanel(index);
        }
    }

    openPanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        
        header.classList.add('active');
        header.setAttribute('aria-expanded', 'true');
        content.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
        
        // Set up ResizeObserver to handle lazy-loaded images and dynamic content
        if (!content._resizeObserver) {
            content._resizeObserver = new ResizeObserver(() => {
                if (header.classList.contains('active')) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            });
            content._resizeObserver.observe(content);
        }
    }

    closePanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        
        header.classList.remove('active');
        header.setAttribute('aria-expanded', 'false');
        content.classList.remove('active');
        content.style.maxHeight = '0px';
    }

    closeAllPanels() {
        this.headers.forEach((_, index) => {
            this.closePanel(index);
        });
    }

    openAllPanels() {
        this.headers.forEach((_, index) => {
            this.openPanel(index);
        });
    }

    focusNextHeader(currentIndex) {
        const nextIndex = (currentIndex + 1) % this.headers.length;
        this.headers[nextIndex].focus();
    }

    focusPreviousHeader(currentIndex) {
        const prevIndex = currentIndex === 0 ? this.headers.length - 1 : currentIndex - 1;
        this.headers[prevIndex].focus();
    }

    destroy() {
        // Clean up ResizeObservers
        this.contents.forEach(content => {
            if (content._resizeObserver) {
                content._resizeObserver.disconnect();
                delete content._resizeObserver;
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('[data-accordion]');
    accordions.forEach(accordion => {
        new Accordion(accordion);
    });
});

function initAccordion(selector, options = {}) {
    const element = document.querySelector(selector);
    if (element) {
        return new Accordion(element, options);
    }
}

// =============== =============== =============== =============== =============== =============== SLIDER
(function() {
  'use strict';
  
  // ===== SLIDER-SPECIFIC SELECTORS =====
  const SLIDER_CONTAINER = '.co-p-main-slider';
  const LAYER_1_SELECTOR = '.co-p-main-image-1';
  const LAYER_2_SELECTOR = '.co-p-main-image-2';
  const LAYER_3_SELECTOR = '.co-p-main-image-3';
  const LAYER_4_SELECTOR = '.co-p-main-image-4';

// ===== NAV-SLIDER SELECTORS =====
  const NAV_SLIDER_CONTAINER = '.co-p-main-nav-slider';

  // ===== TRANSFORM VALUES =====
  const LAYER_1_SCALE = -1;
  const LAYER_2_MIRROR_MULTIPLIER = -1;
  const LAYER_3_SCALE = 0.5;
  const LAYER_4_PERCENTAGE_MULTIPLIER = 0.5;
  
  // Scale configuration - adjust these values as needed
  const SCALE_ACTIVE = 1;    // Scale for centered/active slide
  const SCALE_INACTIVE = 0.75; // Scale for non-centered slides

  // ===== FLICKITY INITIALIZATION =====
  const flkty = new Flickity(SLIDER_CONTAINER, {
    // autoPlay: 2500,
    selectedAttraction: 0.01,
    friction: 0.2,
    wrapAround: true,
    draggable: true,
    prevNextButtons: true,
    arrowShape: ''
  });

// ===== NAV FLICKITY INITIALIZATION =====
  const navFlkty = new Flickity(NAV_SLIDER_CONTAINER, {
    asNavFor: SLIDER_CONTAINER,
    selectedAttraction: 0.01,
    friction: 0.2,
    cellAlign: 'center',
    contain: true,
    wrapAround: false,
    draggable: true,
    prevNextButtons: false,
    pageDots: false,
    arrowShape: ''
  });

  // Expose instances globally for variant sync
  window.flkty = flkty;
  window.navFlkty = navFlkty;

  // ===== HELPER FUNCTIONS (SCOPED TO THIS SLIDER) =====

  function getTranslateX(slider) {
    const style = window.getComputedStyle(slider);
    const matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m41;
  }

  function mirrorTranslateX(translateX, selector, scale = 1) {
    // Only select elements within this slider's context
    const sliderContainer = document.querySelector(SLIDER_CONTAINER);
    if (!sliderContainer) return;
    
    const elements = sliderContainer.querySelectorAll(selector);
    const scaledTranslateX = translateX * scale;
    elements.forEach(function(element) {
      element.style.transform = `translateX(${scaledTranslateX}px)`;
    });
  }

  function handleCellTransforms(flickityInstance) {
    flickityInstance.cells.forEach(function(cell) {
      const originalTransform = cell.element.style.transform;
      const translateXMatch = originalTransform.match(/translateX\((-?\d+(\.\d+)?)%\)/);
      
      if (translateXMatch) {
        const translateXValue = parseFloat(translateXMatch[1]);
        
        // Layer 2: Mirror the original translateX value
        const mirroredTranslateXValue = translateXValue * LAYER_2_MIRROR_MULTIPLIER;
        const childElement1 = cell.element.querySelector(LAYER_2_SELECTOR);
        if (childElement1) {
          childElement1.style.transform = `translateX(${mirroredTranslateXValue}%)`;
        }
        
        // Layer 4: Apply percentage multiplier
        const percentageTranslateXValue = translateXValue * LAYER_4_PERCENTAGE_MULTIPLIER;
        const childElement2 = cell.element.querySelector(LAYER_4_SELECTOR);
        if (childElement2) {
          childElement2.style.transform = `translateX(${percentageTranslateXValue}%)`;
        }
      }
    });
  }

  function getClosestSlideIndex() {
    const viewport = flkty.viewport;
    const viewportCenter = viewport.offsetWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;
    
    flkty.cells.forEach((cell, index) => {
      const slide = cell.element;
      const slideRect = slide.getBoundingClientRect();
      const viewportRect = viewport.getBoundingClientRect();
      const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
      
      const distanceFromCenter = Math.abs(slideCenterX - viewportCenter);
      
      if (distanceFromCenter < closestDistance) {
        closestDistance = distanceFromCenter;
        closestIndex = index;
      }
    });
    
    return closestIndex;
  }

  function updateIsSelectedClass(selectedIndex) {
    flkty.cells.forEach((cell, index) => {
      const slide = cell.element;
      if (index === selectedIndex) {
        slide.classList.add('is-selected');
      } else {
        slide.classList.remove('is-selected');
      }
    });
  }

  function updateCellClasses(selectedIndex) {
    const totalCells = flkty.cells.length;
    
    // Calculate prev and next indices (with wrapping)
    const prevIndex = (selectedIndex - 1 + totalCells) % totalCells;
    const nextIndex = (selectedIndex + 1) % totalCells;
    
    // Remove existing classes from all cells
    flkty.cells.forEach(function(cell) {
      cell.element.classList.remove('is-prev', 'is-next');
    });
    
    // Add classes to prev and next cells
    if (flkty.cells[prevIndex]) {
      flkty.cells[prevIndex].element.classList.add('is-prev');
    }
    if (flkty.cells[nextIndex]) {
      flkty.cells[nextIndex].element.classList.add('is-next');
    }
  }

  function updateSlideEffects() {
    const viewport = flkty.viewport;
    const viewportCenter = viewport.offsetWidth / 2;
    
    flkty.cells.forEach((cell, index) => {
      const slide = cell.element;
      const scaleTarget = slide.querySelector('.co-p-main-cell-frame');
      
      if (scaleTarget) {
        scaleTarget.style.transformOrigin = 'center center';
        
        const slideRect = slide.getBoundingClientRect();
        const viewportRect = viewport.getBoundingClientRect();
        const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
        const slideWidth = slideRect.width;
        
        // Calculate distance from center in slide widths
        const distanceFromCenter = Math.abs(slideCenterX - viewportCenter) / slideWidth;
        
        let scale;
        
        if (distanceFromCenter <= 1) {
          // Within 1 slide width from center: smooth scaling from active to inactive
          // At distance 0: scale = 1 (SCALE_ACTIVE)
          // At distance 1: scale = 0.9 (SCALE_INACTIVE)
          const scaleDifference = SCALE_ACTIVE - SCALE_INACTIVE;
          scale = SCALE_ACTIVE - (distanceFromCenter * scaleDifference);
          scale = Math.max(scale, SCALE_INACTIVE);
        } else {
          // Beyond 1 slide width: always inactive scale
          scale = SCALE_INACTIVE;
        }
        
        scaleTarget.style.transform = `scale(${scale})`;
      }
    });
  }

  function updateTransforms() {
    // Use scoped slider selector instead of generic '.flickity-slider'
    const slider = document.querySelector(`${SLIDER_CONTAINER} .flickity-slider`);
    if (!slider) return;
    
    const translateX = getTranslateX(slider);
    
    // Original image layers
    mirrorTranslateX(translateX, LAYER_1_SELECTOR, LAYER_1_SCALE);
    mirrorTranslateX(translateX, LAYER_3_SELECTOR, LAYER_3_SCALE);
    
    handleCellTransforms(flkty);
    
    // Update slide scaling effects
    updateSlideEffects();
    
    // Update cell classes dynamically
    const closestSlideIndex = getClosestSlideIndex();
    updateCellClasses(closestSlideIndex);
    updateIsSelectedClass(closestSlideIndex);
  }

  // ===== EVENT LISTENERS =====
  flkty.on('ready', function() {
    // Initial transform update after flkty is fully initialized
    updateTransforms();
  });
  flkty.on('dragMove', function() {
    updateTransforms();
  });
  flkty.on('scroll', updateTransforms);
  flkty.on('settle', function() {
    updateTransforms();
    // Also update classes when settling completes
    updateCellClasses(flkty.selectedIndex);
    updateIsSelectedClass(flkty.selectedIndex);
  });
  flkty.on('select', function() {
    updateCellClasses(flkty.selectedIndex);
    updateIsSelectedClass(flkty.selectedIndex);
  });

})();

// =============== =============== =============== =============== =============== =============== VARIANT SYNC
// Direct Variant to Slider Sync using global Flickity instances
(function() {
  'use strict';
  
  // Function to find slide index for a variant
  function findSlideForVariant(variantId) {
    if (!variantId) return null;
    
    const mainSlides = document.querySelectorAll('.co-p-main-cell');
    
    for (let i = 0; i < mainSlides.length; i++) {
      const slide = mainSlides[i];
      const variantIds = slide.getAttribute('data-variant-ids');
      
      if (variantIds) {
        const variantIdArray = variantIds.split(',').map(id => id.trim());
        if (variantIdArray.includes(variantId.toString())) {
          return i;
        }
      }
    }
    
    // Return null if no variant mapping found (don't default to 0)
    return null;
  }
  
  // Function to sync sliders with variant selection
  function syncSlidersWithVariant(variantId) {
    if (!variantId || !window.flkty || !window.navFlkty) {
      return;
    }
    
    const slideIndex = findSlideForVariant(variantId);
    
    // Only sync if there's an actual variant-to-slide mapping
    if (slideIndex === null) {
      return; // Don't move slider if no image is assigned to this variant
    }
    
    try {
      window.flkty.select(slideIndex, false, false);
      window.navFlkty.select(slideIndex, false, false);
      
      // Trigger transform updates
      setTimeout(() => {
        window.flkty.dispatchEvent('scroll');
        window.flkty.dispatchEvent('settle');
      }, 50);
    } catch (error) {
      // Silent error handling
    }
  }
  
  // Function to get current variant ID from multiple sources
  function getCurrentVariantId() {
    // Check URL parameters first
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) {
      return variantFromUrl;
    }
    
    // Check all possible variant inputs
    const variantInputs = document.querySelectorAll('input[name="id"]');
    for (let input of variantInputs) {
      if (input.value && input.value !== '') {
        return input.value;
      }
    }
    
    // Check selected radio buttons to construct variant
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      const selectedOptions = [];
      const radioGroups = variantRadios.querySelectorAll('fieldset');
      
      radioGroups.forEach(fieldset => {
        const selectedRadio = fieldset.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
          selectedOptions.push(selectedRadio.value);
        }
      });
      
      // Find variant that matches these options
      if (selectedOptions.length > 0) {
        const scriptTag = variantRadios.querySelector('script[type="application/json"]');
        if (scriptTag) {
          try {
            const variants = JSON.parse(scriptTag.textContent);
            const matchingVariant = variants.find(variant => {
              return selectedOptions.every((option, index) => {
                const variantOption = variant[`option${index + 1}`];
                return variantOption === option;
              });
            });
            
            if (matchingVariant) {
              return matchingVariant.id.toString();
            }
          } catch (e) {
            // Silent error handling
          }
        }
      }
    }
    
    return null;
  }
  
  // Set up variant change detection
  function setupVariantChangeDetection() {
    // Listen for radio button changes
    document.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.closest('variant-radios')) {
        setTimeout(() => {
          const currentVariantId = getCurrentVariantId();
          if (currentVariantId) {
            syncSlidersWithVariant(currentVariantId);
          }
        }, 100);
      }
    });
    
    // Listen for select changes
    document.addEventListener('change', (e) => {
      if (e.target.tagName === 'SELECT' && e.target.closest('variant-selects')) {
        setTimeout(() => {
          const currentVariantId = getCurrentVariantId();
          if (currentVariantId) {
            syncSlidersWithVariant(currentVariantId);
          }
        }, 100);
      }
    });
  }
  
  // Initialize everything
  function initialize() {
    // Wait for Flickity instances to be available
    const checkFlickity = () => {
      if (window.flkty && window.navFlkty) {
        setupVariantChangeDetection();
        
        // Sync with initial variant
        const initialVariantId = getCurrentVariantId();
        if (initialVariantId) {
          setTimeout(() => {
            syncSlidersWithVariant(initialVariantId);
          }, 500);
        }
      } else {
        setTimeout(checkFlickity, 500);
      }
    };
    
    checkFlickity();
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 1000);
  }
  
})();

// =============== =============== =============== =============== =============== =============== INGREDIENTS SECTION
(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-p-ingredients-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-p-ingredients-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();

// =============== =============== =============== =============== =============== =============== RECIPES SECTION
(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-p-recipes-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-p-recipes-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();
